export const getCountryValue = (
  detectedCountry: string,
  userSelectedCountry?: string
): string | undefined => {
  const ignorePreselect = ['NL'];

  if (userSelectedCountry) {
    return userSelectedCountry;
  }

  if (ignorePreselect.includes(detectedCountry)) {
    return;
  }

  return detectedCountry;
};

export const findUserState = (lookupValue: string, states: { value: string; text: string }[]) =>
  states.find(({ value }) => value === lookupValue);
